<div fxLayout="column">
    <header fxFlex="10%">
        <app-header></app-header>
    </header>
    <main>
        <app-sidenav></app-sidenav>
        <router-outlet></router-outlet>    
    </main>
    <app-footer></app-footer>
</div>